// extracted by mini-css-extract-plugin
export var largeImage = "story-module--largeImage--cEeYa";
export var story__content = "story-module--story__content--DGqGE";
export var story__fullImageContent = "story-module--story__fullImageContent--GOgV2";
export var story__heading = "story-module--story__heading--W822o";